export const logger = (prefix?: string) => {
  return {
    log: (...args: Parameters<typeof console.log>) => {
      if (import.meta.env.PROD) {
        return
      }

      const elements = prefix ? [prefix, ...args] : args
      console.log(...elements)
    },
    warn: (...args: Parameters<typeof console.log>) => {
      if (import.meta.env.PROD) {
        return
      }
      const elements = prefix ? [prefix, ...args] : args
      console.warn(...elements)
    },
    error: (...args: Parameters<typeof console.error>) => {
      if (import.meta.env.PROD) {
        return
      }
      const elements = prefix ? [prefix, ...args] : args
      console.error(...elements)
    },
    debug: (...args: Parameters<typeof console.debug>) => {
      if (import.meta.env.PROD) {
        return
      }
      const elements = prefix ? [prefix, ...args] : args
      console.debug(...elements)
    },
    trace: (...args: Parameters<typeof console.trace>) => {
      if (import.meta.env.PROD) {
        return
      }
      const elements = prefix ? [prefix, ...args] : args
      console.trace(...elements)
    },
  }
}

export const log = logger()
